"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const StyledItemBannerHeader = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "headerAlignment" && prop !== "roundedFirstTile" && prop !== "roundedLastTile"
})(
  ({
    backgroundColor,
    headerAlignment,
    roundedFirstTile,
    roundedLastTile
  }) => ({
    alignItems: "center",
    background: backgroundColor,
    borderTopLeftRadius: roundedFirstTile ? "10px" : 0,
    borderTopRightRadius: roundedLastTile ? "10px" : 0,
    display: "flex",
    height: "4.65rem",
    justifyContent: headerAlignment,
    padding: SpaceXs,
    position: "relative",
    sx: { textAlign: headerAlignment }
  })
);
const StyledItemBannerCircleImage = styled(CostcoBox)`
    border-radius: 50%;
    left: ${SpaceXs};
    overflow: hidden;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;
const StyledItemBannerFooter = styled(Text)(
  ({
    backgroundColor,
    color,
    footerAlignment
  }) => ({
    background: backgroundColor,
    color,
    justifyContent: footerAlignment,
    padding: "6px 16px"
  })
);
export {
  StyledItemBannerCircleImage,
  StyledItemBannerFooter,
  StyledItemBannerHeader
};
